import { render, staticRenderFns } from "./language-modal.vue?vue&type=template&id=11521e80&"
import script from "./language-modal.vue?vue&type=script&lang=js&"
export * from "./language-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports